// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2AgK_","inputWrap":"styles_inputWrap__ooMNw","input":"styles_input__glxd0"};